import { flushQueue } from '@/utils/deferredAction.queue'

/**
 * Mixpanel Queue Plugin
 *
 * This plugin listens for Unleash feature flag loading mutations and triggers
 * the flushing of queued Mixpanel events.
 *
 * We use the 'mixpanel_anonymous' and 'mixpanel_auth' buckets to distinguish
 * these events from other potential deferred actions.
 */
const mixpanelQueuePlugin = (store) => {
  store.subscribe((mutation) => {
    switch (mutation.type) {
      case 'featureToggles/setAnonymousFlag':
        if (mutation.payload === true) {
          flushQueue('mixpanel_anonymous')
        }
        break
      case 'featureToggles/setAuthFlag':
        if (mutation.payload === true) {
          flushQueue('mixpanel_auth')
        }
        break
      default:
        break
    }
  })
}

export default mixpanelQueuePlugin
